export const LAB_VIEW_KEY = "lawlow.labs.view.v1";
export const LAB_SAVED_KEY = "lawlow.labs.saved.v1";
export const LAB_RECENT_KEY = "lawlow.labs.recent.v1";
export const LAB_PAGE_SIZE = 12;
export const DEFAULT_LAB_VIEW = { query: "", category: "all", view: "all", sort: "newest", page: 1, scrollY: 0, catalogIds: [] };

export function readLabStorage(key, fallback, session = false) {
  try { return JSON.parse((session ? window.sessionStorage : window.localStorage).getItem(key)) ?? fallback; }
  catch (_) { return fallback; }
}

export function writeLabStorage(key, value, session = false) {
  try { (session ? window.sessionStorage : window.localStorage).setItem(key, JSON.stringify(value)); }
  catch (_) { /* Browsing still works when storage is unavailable. */ }
}

export function readLabIds(key) {
  const ids = readLabStorage(key, []);
  return Array.isArray(ids) ? [...new Set(ids.filter((id) => typeof id === "string"))] : [];
}

export function markLabVisited(id) {
  writeLabStorage(LAB_RECENT_KEY, [id, ...readLabIds(LAB_RECENT_KEY).filter((item) => item !== id)].slice(0, 24));
}

export function readLabView() {
  const stored = readLabStorage(LAB_VIEW_KEY, {}, true);
  return {
    ...DEFAULT_LAB_VIEW,
    query: typeof stored.query === "string" ? stored.query.slice(0, 100) : "",
    category: typeof stored.category === "string" ? stored.category : "all",
    view: ["all", "new", "saved", "recent"].includes(stored.view) ? stored.view : "all",
    sort: stored.sort === "name" ? "name" : "newest",
    page: Number.isInteger(stored.page) && stored.page > 0 ? stored.page : 1,
    scrollY: Number.isFinite(stored.scrollY) && stored.scrollY > 0 ? stored.scrollY : 0,
    catalogIds: Array.isArray(stored.catalogIds) ? stored.catalogIds.filter((id) => typeof id === "string") : [],
  };
}

export function publishedLabServices(services, now = Date.now()) {
  return services.filter((service) => service.status === "published" && Date.parse(service.publishedAt) <= now);
}

function isRecentDate(value, now) {
  const age = now - Date.parse(value);
  return age >= 0 && age < 7 * 24 * 60 * 60 * 1000;
}

export function labFreshness(service, now = Date.now()) {
  if (isRecentDate(service.publishedAt, now)) return "새 서비스";
  if (Date.parse(service.updatedAt) > Date.parse(service.publishedAt) && isRecentDate(service.updatedAt, now)) return "업데이트";
  return "";
}

export function selectLabServices(services, filters, savedIds = [], recentIds = [], now = Date.now()) {
  const words = filters.query.trim().toLocaleLowerCase("ko").split(/\s+/).filter(Boolean);
  const normalized = (text) => text.toLocaleLowerCase("ko").replace(/\s+/g, "");
  const found = publishedLabServices(services, now).filter((service) => {
    if (filters.category !== "all" && service.category !== filters.category) return false;
    if (filters.view === "saved" && !savedIds.includes(service.id)) return false;
    if (filters.view === "recent" && !recentIds.includes(service.id)) return false;
    if (filters.view === "new" && !isRecentDate(service.publishedAt, now)) return false;
    const text = normalized([service.name, service.problem, service.description, service.output, service.category, ...service.keywords].join(" "));
    return words.every((word) => text.includes(normalized(word)));
  });
  return found.sort((a, b) => {
    if (filters.view === "recent") return recentIds.indexOf(a.id) - recentIds.indexOf(b.id);
    if (filters.sort === "name") return a.name.localeCompare(b.name, "ko");
    return Date.parse(b.publishedAt) - Date.parse(a.publishedAt) || a.name.localeCompare(b.name, "ko");
  });
}

// 배포된 페이지는 등록 API를 기다리지 않고 목록에 보인다.
// 같은 id가 카탈로그에 있으면 운영이 관리하는 카탈로그 쪽을 쓴다.
// 다만 정상 빈 목록은 운영이 전체를 내린 상태이므로 그대로 따른다.
export function mergeBundledServices(catalog, bundled) {
  if (catalog.length === 0) return catalog;
  const registered = new Set(catalog.map((service) => service.id));
  return [...catalog, ...bundled.filter((service) => !registered.has(service.id))];
}
